import {AuthenticatorExceptions} from '@/exceptions/authenticator/AuthenticatorExceptions';

export interface LoginError {
    tone: 'bad' | 'warn';
    title: string;
    text: string;
    /** Too many wrong passwords: the main button leads to "Passwort vergessen" */
    locked?: boolean;
}

/** Texts for the errors of the authenticator (wording of the mockup 11.10.2026) */
export function loginErrorFor(e: unknown): LoginError {
    if (e instanceof AuthenticatorExceptions.TooManyLoginAttemptsException) {
        return {
            tone: 'warn',
            locked: true,
            title: 'Zugang vorübergehend gesperrt',
            text: 'Es gab zu viele falsche Passwörter. Setze dein Passwort zurück, damit wird der Zugang wieder freigegeben.',
        };
    }
    if (e instanceof AuthenticatorExceptions.InactiveLoginException) {
        return {tone: 'warn', title: 'Zugang nicht aktiv', text: e.message};
    }
    if (e instanceof AuthenticatorExceptions.InvalidCredentialsException) {
        return {tone: 'bad', title: 'E-Mail oder Passwort stimmt nicht', text: 'Prüfe die Schreibweise und die Feststelltaste.'};
    }
    const status = (e as { response?: { status?: number } })?.response?.status;
    if (!status) {
        return {tone: 'bad', title: 'Keine Verbindung', text: 'Vanilla ist gerade nicht erreichbar. Prüfe deine Internetverbindung und versuche es erneut.'};
    }
    return {tone: 'bad', title: 'Anmelden hat nicht geklappt', text: 'Bitte versuche es gleich noch einmal.'};
}
